import { SysTheme } from "__SYSDefault/Theme";
import { ColorX } from "../../../../STATIC";

let styles = {
  container: {
    width: "auto",
    paddingLeft: 5,
    paddingRight: 5,
    paddingVertical: 0
  },
  inner: {
    borderRadius: 20,
    paddingVertical: 0,
    height: 30
  },
  innerBlock: {
    width: "100%", 
    flex: 1
  },
  miniInner: {
    borderRadius: 20,
    paddingVertical: 0,
    height: 30
  },
  miniInnerBlock: {
    width: "100%",
    flex: 1
  },
  datepicker: {
    padding: 5,
    flex: 1
  },
  miniDatepicker: {
    padding: 5,
    width: "100%"
  },
  text: {
    flex: 1,
    width: "100%", 
    fontWeight: "bold",
    textAlign: "center"
  },
  miniText: {
    width: "100%",
    fontWeight: "bold",
    textAlign: "center"
  },
  shiftbtn: {
    height: 28
  },
  modepopheader: {
    paddingLeft: 15,
    paddingRight: 15,
    paddingTop: 8,
    paddingBottom: 8,
    borderBottomWidth: 1,
    backgroundColor: ColorX.CSS("cmDarkBlue", 0.8),
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10
  },
  modepoplabel: {
    color: SysTheme?.BGColors?.Primary ?? ColorX.CSS("pureWhite")
  },
  modepoptext: {
    color: SysTheme?.BGColors?.Primary ?? ColorX.CSS("pureWhite"),
    flex: 1,
    textAlign: "center",
    fontWeight: "bold"
  }
};

export default styles;